import Keycloak from 'keycloak-js';

let keycloakInstance = null;
let keycloakPromise = null;

export function getKeycloak() {
  if (keycloakInstance) {
    return Promise.resolve(keycloakInstance);
  }

  if (keycloakPromise) {
    return keycloakPromise;
  }

  const keycloak = new Keycloak({
    // PROD --> 'https://aladyn2.qualitygroup.it/auth'
    // DEV --> 'https://aladyn2.torino.qualitygroup.it/auth'
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: 'qualitygroup',
    clientId: 'qg-cms-webapp'
  });

  keycloakPromise = keycloak.init({
    onLoad: 'login-required',
    redirectUri:  window.location.origin + '/#/login',
    checkLoginIframe: false,
    responseMode: 'query'
  }).then(authenticated => {
    if (authenticated) {
      keycloakInstance = keycloak;
      keycloakPromise = null;
      return keycloak;
    } else {
      keycloak.login();
    }
  }).catch(error => {
    console.error('Errore durante l\'inizializzazione di Keycloak', error);
    keycloakPromise = null;
    throw error;
  });

  return keycloakPromise;
}

export function kc_logout() {
  getKeycloak().then(keycloak => {
    keycloak.logout({ redirectUri: window.location.origin });
  }).catch(error => {
    console.error('Errore durante il logout da Keycloak', error);
  });
}


export function refreshToken() {
  getKeycloak().then(keycloak => {
    keycloak.updateToken(30);
  }).catch(error => {
    console.error('Errore durante il refresh del token', error);
  });
}